import React from "react";
import styled from "styled-components";
import { Icon } from "@onelogin/react-components";

const MainMessage = styled.div`
  font-size: 16px;
  color: #3f4040;
  margin-top: 16px;
`;

const AlertDialogContent = ({ children }) => (
  <>
    <Icon name="Alert" size="48px" alt="" />
    <MainMessage>{children}</MainMessage>
  </>
);

export default AlertDialogContent;
